/**
 * What: Shopify "Tests home" (post-install root screen redesign) merchant-facing copy.
 * Transport / data-flow: Pure string dictionary segment merged by shopify-component-copy.ts for Shopify UI consumers.
 *
 */
export const shopifyComponentTestsHomeCopy = {
    testsHome: {
        syncRunning: 'Store sync: running · building your buyer profile from your last 60 days of orders',
        syncComplete: 'Store sync: complete · {ago}',
        creditsLabel: '{credits} credits',
        howItWorksAction: 'How it works',
        heroTitle: 'Test your store on hundreds of simulated shoppers.',
        heroBody: "Show them two versions. See which one they'd buy, and why. All before anything changes on your live store.",
        heroAction: 'Start a test',
        heroExampleBadge: 'Example',
        heroExampleTitle: '250 simulated shoppers',
        heroExampleVerdict: 'CLEAR WINNER',
        heroExampleCaption: 'Current photo · New photo',
        heroExampleShareA: 'A 38%',
        heroExampleShareB: 'B 62%',
        heroExampleAlt: 'Example result: 250 simulated shoppers split 38% for the current photo and 62% for the new photo.',
        guideTitle: 'Get set up',
        guideProgress: '{completed} of {total} done',
        guideAriaLabel: 'Setup guide',
        laterAction: 'Later',
        skipAction: 'Skip',
        syncingBadge: 'Syncing',
        doneBadge: 'Done',
        connectTitle: 'Connect your store',
        connectBody: 'Connected at install. TestFeed reads your products and orders. It never reads names, emails or addresses.',
        connectNoteSyncing: 'Your buyer profile is building from your last 60 days of orders. You can keep going below.',
        briefTitle: 'Tell us about your store',
        briefBody: "Two minutes of questions. Your answers ground every suggestion in your store — nothing is generated until you've had this say.",
        briefAction: 'Start the brief',
        briefDeferred: 'Deferred — AI suggestions stay off until done',
        planTitle: 'Choose your plan',
        planBody: "Pick a plan on Shopify's own pricing page — it lands on your Shopify invoice. Credits cover test runs; every run shows its cost before you launch.",
        planAction: 'Choose a plan',
        planDeferred: "Deferred — tests can't run without a plan",
        launchTitle: 'Launch your first test',
        launchBody: 'Pick a product, choose what to test — photo, price or description — and review the suggested versions before anything runs.',
        launchGateBadge: 'Waiting on first sync',
        launchNoteSyncing: 'Your first store sync is still running. You can set everything up now and launch the moment it completes.',
        launchNoteReady: 'Your store data is ready. Suggestions will be grounded in your own catalogue and orders.',
        launchAction: 'Set up a test',
        applyTitle: 'Apply a winner',
        applyBody: 'When a test finds a winner, apply it to your live store in one click. Every change is recorded, and undo restores exactly what was there before.',
        applyNote: 'TestFeed asks for write access the first time you apply — not before.',
        applyAction: 'Got it',
        applyDeferred: 'Skipped — you can always apply results by hand',
        doesTitle: 'What TestFeed does for your store',
        doesAside: 'Opens after setup',
        doesTestKicker: 'TEST',
        doesTestTitle: 'Test products',
        doesTestBody: 'Pit two photos, prices or descriptions against each other.',
        doesLearnKicker: 'LEARN',
        doesLearnTitle: 'Know your buyers',
        doesLearnBody: 'See who buys each product — repeat behaviour, co-purchases, spend.',
        doesImproveKicker: 'IMPROVE',
        doesImproveTitle: "What's worth testing",
        doesImproveBody: 'Suggestions grounded in your own store data, ready to test.',
        resultsTitle: 'Your results will show here',
        resultsBody: 'Each test ends with a clear verdict — apply it, keep what you have, or see exactly why it was too close to call.',
        resultsAction: 'Finish setup',
        privacyTitle: 'Private by design',
        privacyBody: 'Simulated shoppers come from buying patterns. No names, emails or addresses are ever collected.',
        privacyLink: 'How we protect data',
        footerLead: 'Learn more about',
        footerLink: 'how TestFeed works',
    },
};
//# sourceMappingURL=tests-home.js.map